import { reactive as I, ref as r, computed as y, useId as L, watch as j, onMounted as B, nextTick as N, withDirectives as b, openBlock as x, createElementBlock as P, normalizeClass as c, createElementVNode as u, unref as a, withKeys as T, withModifiers as S, createVNode as D, Transition as W, withCtx as A, normalizeStyle as E, toDisplayString as H, createBlock as M, createCommentVNode as K, vShow as V } from "vue";
import { resizeAwds as q } from "../../utils/directives/resize.js";
import U from "../../utils/directives/click-outside.js";
import F from "../../atoms/icon/icon.vue.js";
import G from "../link/link.vue.js";
import { themeProp as J } from "../../composables/useTheme.js";
import { useTracking as Q } from "../../composables/useTracking.js";
/* empty css             */
const X = ["data-track-component-name", "onKeydown"], Y = ["id", "aria-hidden"], m = 327, $ = 24, Z = /* @__PURE__ */ Object.assign({
  name: "DsTooltip"
}, {
  __name: "tooltip",
  props: {
    ...J,
    description: {
      type: String,
      required: !0
    },
    withSmallText: {
      type: Boolean,
      default: !1
    },
    link: {
      type: Object,
      default: null,
      validator: (t) => ["title", "url", "openInNewWindow", "nuxt"].every((d) => d in t)
    }
  },
  emits: ["link-clicked", "item-shown"],
  setup(t, { emit: d }) {
    const O = q(), z = d, { trackingDataProvided: f } = Q(), n = I({
      left: 0,
      right: 0
    }), i = r(!1), o = r(!1), p = r(null), C = y(
      () => n.left <= m / 2 ? `-${n.left}px` : ""
    ), R = y(
      () => n.right <= m / 2 ? `-${n.right}px` : `calc(50% - ${m / 2}px)`
    ), w = L(), k = () => {
      i.value = !i.value, o.value = i.value;
    }, v = () => {
      o.value && (o.value = i.value = !1);
    }, h = (e) => {
      i.value || !e || (o.value = e.type !== "mouseleave");
    }, g = () => {
      if (typeof window > "u")
        return;
      const e = typeof window < "u" ? window.innerWidth : 0, l = p.value, s = l == null ? void 0 : l.getBoundingClientRect();
      if (!s) {
        n.left = 0, n.right = 0;
        return;
      }
      n.left = s.left - $, n.right = e - s.right - $;
    };
    return j(o, (e) => {
      e === !0 && z("item-shown", { label: "info" });
    }), B(async () => {
      await N(), g();
    }), (e, l) => b((x(), P("div", {
      class: c(`ds-tooltip ds-tooltip--${e.theme}`),
      onMouseover: h,
      onMouseleave: h
    }, [
      u("button", {
        ref_key: "tooltipRef",
        ref: p,
        "data-track-component-name": a(f)["component-name"] || e.$options.name,
        type: "button",
        tabindex: "0",
        class: "ds-tooltip__button",
        "data-j-button": "",
        onClick: k,
        onKeydown: [
          T(S(k, ["prevent"]), ["enter"]),
          T(S(v, ["prevent"]), ["escape"])
        ]
      }, [
        D(F, {
          "aria-describedby": `tooltip-box-${a(w)}`,
          name: "info-filled",
          category: "interface",
          class: c(["ds-tooltip__icon", { "ds-tooltip__icon--active": i.value }])
        }, null, 8, ["aria-describedby", "class"])
      ], 40, X),
      D(W, { name: "fade" }, {
        default: A(() => [
          b(u("div", {
            id: `tooltip-box-${a(w)}`,
            role: "tooltip",
            "aria-hidden": !o.value,
            style: E({ left: C.value, right: R.value }),
            class: "ds-tooltip__tooltip-box ds-shadow"
          }, [
            u("p", {
              class: c(t.withSmallText ? "ds-text-small" : "ds-text"),
              "data-j-text": ""
            }, H(t.description), 3),
            t.link ? (x(), M(G, {
              key: 0,
              "tracking-data": { "component-name": e.$options.name, text: t.link.title, ...a(f) },
              url: t.link.url,
              "lazy-url-endpoint": t.link.lazyUrlEndpoint,
              "open-in-new-window": t.link.openInNewWindow,
              nuxt: t.link.nuxt,
              content: t.link.title,
              class: c([{ "ds-text-small": t.withSmallText }, "ds-margin-top-24"]),
              "data-j-link": "",
              onLinkClicked: l[0] || (l[0] = (s) => e.$emit("link-clicked", { ...s, label: t.link.title }))
            }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "open-in-new-window", "nuxt", "content", "class"])) : K("", !0)
          ], 12, Y), [
            [V, o.value]
          ])
        ]),
        _: 1
      })
    ], 34)), [
      [a(U), v],
      [a(O), g]
    ]);
  }
}), st = Z;
export {
  st as default
};
